import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onSelectAll: () => void;
  onSelectNone: () => void;
  // What the links act on, already translated. The picker can show two pairs,
  // and a screen reader's button list has only their names to tell them apart.
  scopeLabel: string;
  // Each link's test id is this plus `_select-all` or `_select-none`.
  dataCyPrefix: string;
};

const linkClassName =
  'tw-cursor-pointer tw-text-primary-100 hover:tw-underline focus-visible:tw-underline';

// "Select all · None", for a whole list or for one portfolio's pages.
const BulkSelectLinks: FC<Props> = ({
  onSelectAll,
  onSelectNone,
  scopeLabel,
  dataCyPrefix,
}) => {
  const { t } = useTranslation();

  return (
    <span className="tw-flex tw-shrink-0 tw-items-center tw-gap-1 tw-text-sm tw-font-semibold">
      <button
        type="button"
        className={linkClassName}
        onClick={onSelectAll}
        aria-label={`${t('selectAll')}: ${scopeLabel}`}
        data-cy={`${dataCyPrefix}_select-all`}
      >
        {t('selectAll')}
      </button>
      <span className="tw-text-grayscale-100" aria-hidden>
        ·
      </span>
      <button
        type="button"
        className={linkClassName}
        onClick={onSelectNone}
        aria-label={`${t('none')}: ${scopeLabel}`}
        data-cy={`${dataCyPrefix}_select-none`}
      >
        {t('none')}
      </button>
    </span>
  );
};

export default BulkSelectLinks;
